import { gtm } from '@uncinc/uncinc-react-kitchen-sink';

export const initGtmPlausibleInterceptor = () => {
  // Store the original push method.
  const originalPush = gtm.push;

  gtm.push = function(...args) {
    // Process each argument, there can be more pushed at once.
    args.forEach((data) => {
      if (typeof data === 'object' && !Array.isArray(data) && data !== null) {
        // Check if it is a GTM event (has 'event' property).
        if (data.event) {
          const { event, ...params } = data;

          // Send to Plausible.
          if (globalThis.plausible) {
            try {
              globalThis.plausible(event, { props: params });
            } catch (err) {
              console.error('Failed to send event to Plausible:', err);
            }
          } else {
            console.warn('Plausible not available, skipping event:', event);
          }
        }
      }
    });

    return originalPush.apply(gtm, args);
  };
};
